module.exports = __webpack_public_path__ + "assets/img/4481e842ea33026df3d9f2f1aa006f71.svg";